<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrighta"><a id="page_4"></a>This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.</p>
<p class="copyright">FOXMASK</p>
<p class="copyright">Copyright © 2003 by Juliet Marillier</p>
<p class="copyright">First published in 2003 by Pan Macmillan Australia Pty Limited</p>
<p class="copyright">All rights reserved, including the right to reproduce this book, or portions thereof, in any form.</p>
<p class="copyright">This book is printed on acid-free paper.</p>
<p class="copyright">Maps by Bronya Marillier</p>
<p class="copyright">A Tor Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="copyright"><span class="weblink"><a class="nounder" href="http://www.tor.com" target="_blank">www.tor.com</a></span></p>
<p class="copyright">Tor<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyrightb">Marillier, Juliet.<br/>Foxmask / Juliet Marillier.—1st Tor ed.</p>
<p class="copyrightc">p. cm.</p>
<p class="copyrightd">“A Tom Doherty Associates book.”</p>
<p class="copyrightd">ISBN   0-765-30674-3</p>
<p class="copyrightd">EAN   978-0765-30674-6</p>
<p class="copyrightd">1. Vikings—Fiction. 2. Birthfathers—Fiction. 3. Fathers and sons—Fiction.4. Orkney (Scotland)—Fiction. I. Title.</p>
<p class="copyrightb1">PR9619.3.M26755F69    2004<br/>823’.92—dc22</p>
<p class="copyright1">2003071154</p>
<p class="copyright">First U.S. Edition: August 2004</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">0  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?02d8dbc1